import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=fadfffe8&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=fadfffe8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadfffe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fadfffe8')) {
      api.createRecord('fadfffe8', component.options)
    } else {
      api.reload('fadfffe8', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=fadfffe8&scoped=true&", function () {
      api.rerender('fadfffe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/sharing_agreement/terminal_report/form/detail.vue"
export default component.exports